import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'


Vue.use(Vuex);
const vuexPersist = new VuexPersist({
  key: 'ttc-portal-app',
  storage: window.localStorage,
  reducer: (state) => ({
    token: state.token,
    userPrivilege: state.userPrivilege,
    userProfile: state.userProfile,
  }),

})

export default new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    token: null,
    userPrivilege: null,
    userProfile: null,
    ttcapps:[],
    ttcsub_apps:[],
    activeApp: null,
  },
  mutations: {
    setToken(state, payload) {
      state.token = payload
    },
    setUserPrivilege(state, payload) {
      state.userPrivilege = payload
    },
    setUserProfile(state, payload) {
      state.userProfile = payload
    },
    setApps(state, payload) {
      state.ttcapps = payload
    },
    setSubApps(state, payload) {
      state.ttcsub_apps = payload
    },
    setActiveApp(state, payload) {
      state.activeApp = payload
    },
  },
  actions: {
    setUser (context, {UserPrivilege, UserProfile, token2}) {
      context.commit('setToken', token2);
      context.commit('setUserProfile', UserProfile);
      context.commit('setUserPrivilege', UserPrivilege);
    },

    logoutAction (context, {UserPrivilege, UserProfile, token}) {
      context.commit('setToken', null);
      context.commit('setUserProfile', null);
      context.commit('setUserPrivilege', null);
      context.commit('setActiveApp', null);
    },
    setAppsAction (context, payload) {
      context.commit('setApps', payload);
    },
    setSubAppsAction (context, payload) {
      context.commit('setSubApps', payload);
    },

    setActiveAppAction(context, payload) {
      context.commit('setActiveApp', payload);
    }
  }
})
